import React from "react";
import { useTicket } from "../../../store/Store";
import StripePaymentForm from "./StripePaymentForm";
import Cloud9PaymentForm from "./Cloud9PaymentForm";
import StripeProvider from "../providers/StripeProvider";

const CreditCardForm = ({ addPaymentMethod = false }) => {
  const { data: ticketData } = useTicket();

  if (
    ticketData.resource.payment_account.type === "StripeAccount::NewStripe" &&
    ticketData.resource.payment_account.publishable_key
  ) {
    return (
      <div className="mb-8">
        <StripeProvider
          stripePublishableKey={
            ticketData.resource.payment_account.publishable_key
          }
        >
          <StripePaymentForm addPaymentMethod={addPaymentMethod} />
        </StripeProvider>
      </div>
    );
  }

  if (ticketData.resource.payment_account.type === "StripeAccount::Cloud9") {
    return (
      <div className="mb-8">
        <Cloud9PaymentForm addPaymentMethod={addPaymentMethod} />
      </div>
    );
  }

  return null;
};

export default CreditCardForm;
